import { SocialPostRules } from "../socialPost/interfaces/postError";

export const SOCIAL_POST_RULES: SocialPostRules = {
  maxVideoSize: parseInt(
    process.env.REACT_APP_YOUTUBE_MAX_VIDEO_SIZE ||
      process.env.REACT_APP_DEFAULT_MAX_VIDEO_SIZE ||
      "1024"
  ),
  maxImageSize: parseInt(
    process.env.REACT_APP_YOUTUBE_MAX_IMAGE_SIZE ||
      process.env.REACT_APP_DEFAULT_MAX_IMAGE_SIZE ||
      "10"
  ),
  maxCharactersAllowed: 5000,
  maxPostPhotoAllowed: 0,
  postMediaRequired: true,
  videoAllowed: true,
  imageAllowed: false,
  imageAspectRatioSizeAllowed: [],
  videoAspectRatioSizeAllowed: [0.5625, 1.7778],
  imageAspectRatioAllowed: [],
};
